<template>
  <div class="Shoppe" :class="{'js-header-attached': scrollPosition > 90, 'js-header-not-attached': scrollPosition <= 90}">
    <ProductModal @closemodal="closeModal()" :chosenOption="chosenOption" :product="modalProduct" :show="isModalOpen"></ProductModal>
    <div class="Shoppe__header">
      <div>
        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/header_title.svg?v=1626116290">
        <span class="desktop">
          Shop our best selling products individually  to send as gifts (or for yourself!)
        </span>
        <span class="mobile">
          Shop for you & shop gifts for them: ship items to <br> 
          multiple addresses all in one order
        </span>
      </div>
      <div>
        <button @click="selectCategory(category.value)" v-for="category in categories" :key="category.value">{{category.name}}</button>
      </div>
      <div>
        <span>SORT BY:</span>
        <select @change="sortProducts($event)">
          <option value="-">-</option>
          <option value="asc">Price (low-high)</option>
          <option value="desc">Price (high-low)</option>
        </select>
      </div>
    </div>
    <div class="Shoppe__main">
      <div class="separator"></div>
      <div class="Shoppe__products">
        <ul class="Shoppe__addon-products">
          <li v-for="product in sortedProducts" :key="product.id">
            <ShoppeProduct @openmodal="(sentProduct,option) => loadModal(sentProduct,option)" :product="product"></ShoppeProduct>
          </li>
        </ul>
      </div>
      <div class="Shoppe__sales">
        <div class="Shoppe__sales-header">
          <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/sunicon.svg?v=1626119252">
          <span>HAVE A HAPPY DAY</span>
          <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/cherryicon.svg?v=1626119252">
        </div>
        <div class="Shoppe__products">
          <ul class="Shoppe__addon-products">
            <li v-for="product in featuredProducts" :key="product.id">
              <ShoppeProduct @openmodal="(sentProduct,option) => loadModal(sentProduct,option)" :product="product"></ShoppeProduct>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vueperslides/dist/vueperslides.css'
import Sticky from 'vue-sticky-directive'
import { mapGetters } from 'vuex';
import ShoppeProduct from './components/ShoppeProduct.vue'
import ProductModal from './components/ProductModal.vue'
require('dotenv').config();



export default {
  components:{
    ShoppeProduct,
    ProductModal
  },
  directives: {
    Sticky
  },
  data(){
    return{
      modalProduct: new Object(),
      chosenOption: "",
      modalOpen: false,
      sortOrder: "-",
      categories: [
                    {name: "ALL" ,value: ""},
                    {name: "CLOTHING" ,value: "Category_Baby|Category_Socks|Category_Clothing"},
                    {name: "ACCESSORIES" ,value: "Category_Accessories"},
                    {name: "LIFESTYLE" ,value: "Category_Cocktail_Syrups_Kits|Category_candles_diffusers|category_stationary_stickers"},
                    {name: "WELLNESS" ,value: "Category_Face_masks|Category_Spa_lotion|Category_Tea_coffee"},
                    {name: "CANDY & FUN" ,value: "Category_Snacks|Category_Candy"},
                    //{name: "SALE" ,value: "Category_Sale"}
                  ],
      sortTags: [],
      scrollPosition: 0,
      stickyOffset: {
        top: '90px'
      },
    };
  },
  computed:{
    ...mapGetters([
      'addonProducts',
    ]),
    featuredProducts(){
      return this.addonProducts.filter(x => x.tags.includes("Feature"));
    },
    isModalOpen(){
      if (this.modalOpen)
        return this.modalOpen
      else
      return false
    },
    sortedProducts(){
      var listProducts = JSON.parse(JSON.stringify(this.addonProducts));
      if(this.sortTags.length > 0){
        listProducts = listProducts.filter(x => x.tags.some(t => this.sortTags.includes(t.toUpperCase())));
      }
      if(this.sortOrder == "asc"){
        listProducts.sort(function(a, b) {
          return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price);
        });
      }
      else if(this.sortOrder == "desc"){
        listProducts.sort(function(a, b) {
          return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price) ;
        });
      }

      return listProducts
    }
  },
  methods:{
    sortProducts(order){
      order = order.target.value;
      this.sortOrder = order;
    },
    loadModal(e,option) {
      this.modalProduct = e;
      this.modalOpen = true;
      this.chosenOption = option;
      $("body").addClass("noScroll");
    },
    closeModal(e){
      this.modalOpen = false;
      $("body").removeClass("noScroll");
    },
    selectCategory(selectedCategories){
      if(selectedCategories != ""){
        var categoriesArray = selectedCategories.split("|");
        categoriesArray = categoriesArray.map(x => x.toUpperCase())
        this.sortTags = categoriesArray;
      }
      else {
        this.sortTags = [];
      }
      window.scrollTo(0,0);
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;

      const body = $('body');
      const className = 'js-header-attached';

      if (this.scrollPosition > 90) {
        body.addClass(className);
      } else {
        body.removeClass(className);
      }
    }
  },
  beforeMount(){
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll, { passive: false });
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'updatePage') {
        this.currentPage = mutation.payload.page;
      }
    })  
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  }
}
</script>

<style>
</style>